<template>
    <div>

    </div>
</template>

<script>
import search from "@/libs/search";
export default {
    name: "home",
    components: {},
    data() {
        return {};
    },
    mounted() {

    },

    methods: {}
};
</script>

<style>
p {
    margin-bottom: 6px;
}
p i {
    color: orange;
    margin-right: 4px;
}

p > span {
    color: green;
}

p button {
    margin-left: 8px;
}
.StatNumber {
    color: red;
    font-weight: bold;
    padding-left: 4px;
    padding-right: 4px;
}

.ivu-table-cell {
    padding: 0 !important;
}

/* .ivu-card-head {
    padding: 4px 16px !important;
    border-bottom: 1px solid #e8eaec !important;
    line-height: 0 !important;
}

.upperCard {
    height: 260px;
    overflow:scroll;
} */

.upperCard::-webkit-scrollbar { width: 0 !important }
</style>
